import uiConfig from "../../ui.config.json";

export default (): typeof uiConfig => {
  return uiConfig;
};
